import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<h3>Pembayaran</h3><nav aria-label=\"breadcrumb\"><ol class=\"breadcrumb\"><li class=\"breadcrumb-item active\">Beranda</li><li class=\"breadcrumb-item active\">Bayar SPP</li><li class=\"breadcrumb-item active\" aria-current=\"page\">Pembayaran</li></ol></nav><hr class=\"divider-primary\">", 3)
const _hoisted_4 = { class: "row gx-2" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "card rounded-3 h-100 bg-gradient-primary text-white" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "col-md-2" }, [
  /*#__PURE__*/_createVNode("div", { class: "card-icon m-3" }, [
    /*#__PURE__*/_createVNode("ion-icon", { name: "calendar-outline" })
  ])
], -1)
const _hoisted_10 = { class: "col-md-10" }
const _hoisted_11 = { class: "m-3" }
const _hoisted_12 = /*#__PURE__*/_createVNode("h5", null, "Tagihan", -1)
const _hoisted_13 = { class: "d-inline" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "card h-100" }
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "col-md-2" }, [
  /*#__PURE__*/_createVNode("div", { class: "card-icon m-3 text-primary" }, [
    /*#__PURE__*/_createVNode("ion-icon", { name: "receipt-outline" })
  ])
], -1)
const _hoisted_19 = { class: "col-md-10" }
const _hoisted_20 = { class: "m-3" }
const _hoisted_21 = /*#__PURE__*/_createVNode("h5", null, "Riwayat Pembayaran", -1)
const _hoisted_22 = { class: "d-inline text-primary" }
const _hoisted_23 = { class: "row pt-2" }
const _hoisted_24 = { class: "col-md-12" }
const _hoisted_25 = { class: "card" }
const _hoisted_26 = { class: "card-body" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-md-4 p-2" }
const _hoisted_29 = /*#__PURE__*/_createVNode("ion-icon", { name: "arrow-back-outline" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Kembali ")
const _hoisted_31 = { class: "col-md-8" }
const _hoisted_32 = { class: "float-end" }
const _hoisted_33 = /*#__PURE__*/_createVNode("ion-icon", { name: "refresh-circle-outline" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Refresh")
const _hoisted_35 = { class: "row pt-2" }
const _hoisted_36 = { class: "col-md-12" }
const _hoisted_37 = { class: "card" }
const _hoisted_38 = { class: "card-body" }
const _hoisted_39 = {
  key: 0,
  class: "nav nav-tabs",
  id: "billTabs",
  role: "tablist"
}
const _hoisted_40 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_41 = { class: "table table-borderless table-data fw-bold" }
const _hoisted_42 = /*#__PURE__*/_createVNode("th", null, "No Invoice", -1)
const _hoisted_43 = /*#__PURE__*/_createTextVNode("Total Bayar ")
const _hoisted_44 = /*#__PURE__*/_createVNode("th", null, "Status", -1)
const _hoisted_45 = /*#__PURE__*/_createTextVNode("Batas Bayar ")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("Tanggal Pembayaran ")
const _hoisted_47 = /*#__PURE__*/_createVNode("th", null, "Deskripsi", -1)
const _hoisted_48 = /*#__PURE__*/_createVNode("th", null, null, -1)
const _hoisted_49 = { class: "text-primary" }
const _hoisted_50 = {
  key: 0,
  class: "btn btn-sm btn-outline-secondary rounded-pill no-pointer"
}
const _hoisted_51 = {
  key: 1,
  class: "btn btn-sm btn-outline-secondary rounded-pill no-pointer"
}
const _hoisted_52 = {
  key: 2,
  class: "btn btn-sm btn-outline-success rounded-pill no-pointer"
}
const _hoisted_53 = {
  key: 3,
  class: "btn btn-sm btn-outline-success rounded-pill no-pointer"
}
const _hoisted_54 = {
  key: 4,
  class: "btn btn-sm btn-outline-warning rounded-pill no-pointer"
}
const _hoisted_55 = {
  key: 5,
  class: "btn btn-sm btn-outline-warning rounded-pill no-pointer"
}
const _hoisted_56 = {
  key: 6,
  class: "btn btn-sm btn-outline-info rounded-pill no-pointer"
}
const _hoisted_57 = {
  key: 7,
  class: "btn btn-sm btn-outline-info rounded-pill no-pointer"
}
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { class: "description-table" }
const _hoisted_60 = /*#__PURE__*/_createVNode("ion-icon", { name: "information-circle-outline" }, null, -1)
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" Detail")
const _hoisted_62 = /*#__PURE__*/_createVNode("ion-icon", { name: "refresh-outline" }, null, -1)
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" Refund")
const _hoisted_64 = {
  id: "orderModal",
  class: "modal",
  tabindex: "-1"
}
const _hoisted_65 = { class: "modal-dialog modal-lg" }
const _hoisted_66 = { class: "modal-content" }
const _hoisted_67 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "Detail Pembayaran"),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_68 = { class: "modal-body" }
const _hoisted_69 = {
  key: 0,
  class: "row p-3"
}
const _hoisted_70 = { class: "table table-borderless table-invoice" }
const _hoisted_71 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "bg-primary" }, [
    /*#__PURE__*/_createVNode("th", null, "Nama Tagihan"),
    /*#__PURE__*/_createVNode("th", null, "Bulan"),
    /*#__PURE__*/_createVNode("th", null, "Batas Akhir"),
    /*#__PURE__*/_createVNode("th", { class: "text-end" }, "Total Bayar")
  ])
], -1)
const _hoisted_72 = { class: "badge bg-primary" }
const _hoisted_73 = { class: "text-primary text-end fw-bold" }
const _hoisted_74 = { key: 0 }
const _hoisted_75 = /*#__PURE__*/_createVNode("td", null, "Denda", -1)
const _hoisted_76 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_77 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_78 = { class: "text-primary text-end fw-bold" }
const _hoisted_79 = { key: 1 }
const _hoisted_80 = /*#__PURE__*/_createVNode("td", null, "Biaya Admin", -1)
const _hoisted_81 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_82 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_83 = { class: "text-primary text-end fw-bold" }
const _hoisted_84 = { key: 2 }
const _hoisted_85 = /*#__PURE__*/_createVNode("td", null, "Biaya Merchant", -1)
const _hoisted_86 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_87 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_88 = { class: "text-primary text-end fw-bold" }
const _hoisted_89 = { key: 3 }
const _hoisted_90 = /*#__PURE__*/_createVNode("td", null, "PPN", -1)
const _hoisted_91 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_92 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_93 = { class: "text-primary text-end fw-bold" }
const _hoisted_94 = /*#__PURE__*/_createVNode("td", {
  colspan: "3",
  class: "text-end pt-4 pb-4"
}, [
  /*#__PURE__*/_createVNode("span", { class: "text-secondary fs-3" }, "Jumlah Total")
], -1)
const _hoisted_95 = { class: "text-end pt-4 pb-4" }
const _hoisted_96 = { class: "text-primary fw-bold fs-3" }
const _hoisted_97 = { key: 0 }
const _hoisted_98 = /*#__PURE__*/_createVNode("h4", null, "Deskripsi", -1)
const _hoisted_99 = { key: 1 }
const _hoisted_100 = /*#__PURE__*/_createVNode("h4", null, "Bukti Pembayaran", -1)
const _hoisted_101 = { key: 0 }
const _hoisted_102 = { key: 1 }
const _hoisted_103 = /*#__PURE__*/_createVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn btn-outline-secondary",
    "data-bs-dismiss": "modal"
  }, [
    /*#__PURE__*/_createVNode("ion-icon", { name: "close-outline" }),
    /*#__PURE__*/_createTextVNode(" Tutup")
  ])
], -1)
const _hoisted_104 = {
  id: "refundModal",
  class: "modal",
  tabindex: "-1"
}
const _hoisted_105 = { class: "modal-dialog modal-lg" }
const _hoisted_106 = { class: "modal-content" }
const _hoisted_107 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "Detail Refund"),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_108 = { class: "modal-body" }
const _hoisted_109 = { class: "table table-borderless" }
const _hoisted_110 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "bg-light" }, [
    /*#__PURE__*/_createVNode("th", null, "Nama Tagihan"),
    /*#__PURE__*/_createVNode("th", null, "Bulan"),
    /*#__PURE__*/_createVNode("th", null, "Status"),
    /*#__PURE__*/_createVNode("th", { class: "text-end" }, "Nominal Refund")
  ])
], -1)
const _hoisted_111 = { class: "badge bg-primary" }
const _hoisted_112 = {
  key: 0,
  class: "badge bg-info"
}
const _hoisted_113 = {
  key: 1,
  class: "badge bg-warning"
}
const _hoisted_114 = { class: "text-end fw-bold" }
const _hoisted_115 = { key: 0 }
const _hoisted_116 = /*#__PURE__*/_createVNode("td", {
  colspan: "4",
  class: "text-center"
}, "Tidak ada data refund", -1)
const _hoisted_117 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_118 = { class: "row" }
const _hoisted_119 = { class: "col-12" }
const _hoisted_120 = { class: "text-end" }
const _hoisted_121 = /*#__PURE__*/_createTextVNode("Total Refund: ")
const _hoisted_122 = { class: "text-primary" }
const _hoisted_123 = /*#__PURE__*/_createVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn btn-outline-secondary",
    "data-bs-dismiss": "modal"
  }, [
    /*#__PURE__*/_createVNode("ion-icon", { name: "close-outline" }),
    /*#__PURE__*/_createTextVNode(" Tutup")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode("div", _hoisted_10, [
                _createVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode("h3", _hoisted_13, "Rp" + _toDisplayString(_ctx.toLocaleString((_ctx.stats.total_bill-_ctx.stats.total_paid))), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_14, [
        _createVNode("div", _hoisted_15, [
          _createVNode("div", _hoisted_16, [
            _createVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode("div", _hoisted_19, [
                _createVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createVNode("h3", _hoisted_22, _toDisplayString(_ctx.billCount), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_23, [
      _createVNode("div", _hoisted_24, [
        _createVNode("div", _hoisted_25, [
          _createVNode("div", _hoisted_26, [
            _createVNode("div", _hoisted_27, [
              _createVNode("div", _hoisted_28, [
                _createVNode("h4", null, [
                  _createVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1))),
                    class: "btn btn-light rounded-pill"
                  }, [
                    _hoisted_29
                  ]),
                  _hoisted_30
                ])
              ]),
              _createVNode("div", _hoisted_31, [
                _createVNode("div", _hoisted_32, [
                  _createVNode("button", {
                    class: "btn btn-icon btn-link-gray",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadData()))
                  }, [
                    _hoisted_33,
                    _hoisted_34
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_35, [
      _createVNode("div", _hoisted_36, [
        _createVNode("div", _hoisted_37, [
          _createVNode("div", _hoisted_38, [
            (_ctx.groupBillAsTab === true)
              ? (_openBlock(), _createBlock("ul", _hoisted_39, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.billTypes, (type, index) => {
                    return (_openBlock(), _createBlock("li", {
                      key: index,
                      class: "nav-item",
                      role: "presentation"
                    }, [
                      _createVNode("a", {
                        class: ["nav-link", {'active' : index == 0}],
                        id: type.id+'-tab',
                        "data-bs-toggle": "tab",
                        "aria-current": "page",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.uncheckAllBill())),
                        href: '#'+type.id,
                        role: "tab",
                        "aria-controls": type.id,
                        "aria-selected": "true"
                      }, _toDisplayString(type.name), 11, ["id", "href", "aria-controls"])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_40, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.billTypes, (type, index) => {
                return (_openBlock(), _createBlock("div", {
                  class: ["tab-pane fade table-responsive", {'show active' : index == 0}],
                  key: index,
                  id: type.id,
                  role: "tabpanel",
                  "aria-labelledby": type.id+'-tab'
                }, [
                  _createVNode("table", _hoisted_41, [
                    _createVNode("thead", null, [
                      _createVNode("tr", null, [
                        _hoisted_42,
                        _createVNode("th", null, [
                          _hoisted_43,
                          _createVNode("i", {
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sort('total_amount'))),
                            class: "fa fa-sort"
                          })
                        ]),
                        _hoisted_44,
                        _createVNode("th", null, [
                          _hoisted_45,
                          _createVNode("i", {
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sort('deadline'))),
                            class: "fa fa-sort"
                          })
                        ]),
                        _createVNode("th", null, [
                          _hoisted_46,
                          _createVNode("i", {
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sort('deadline'))),
                            class: "fa fa-sort"
                          })
                        ]),
                        _hoisted_47,
                        _hoisted_48
                      ])
                    ]),
                    _createVNode("tbody", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orders.filter(
                    // order => order.spp_bill_type_ids.includes(type.id)
                      order => _ctx.groupBillAsTab === true ? order.spp_bill_type_ids.includes(type.id) : true
                    ), (order, i) => {
                        return (_openBlock(), _createBlock("tr", { key: i }, [
                          _createVNode("td", null, [
                            _createVNode("a", {
                              href: "javascript:void(0)",
                              class: "text-primary",
                              onClick: ($event: any) => (_ctx.invoice(order.id))
                            }, _toDisplayString(order.invoice_no), 9, ["onClick"])
                          ]),
                          _createVNode("td", _hoisted_49, " Rp" + _toDisplayString(_ctx.toLocaleString(order.total_payment)), 1),
                          _createVNode("td", null, [
                            (order.status == _ctx.constants.ORDER_EXPIRED)
                              ? (_openBlock(), _createBlock("div", _hoisted_50, "KEDALUWARSA"))
                              : _createCommentVNode("", true),
                            (order.status == _ctx.constants.ORDER_CANCELED)
                              ? (_openBlock(), _createBlock("div", _hoisted_51, "DIBATALKAN"))
                              : _createCommentVNode("", true),
                            (order.status == _ctx.constants.ORDER_SUCCESS)
                              ? (_openBlock(), _createBlock("div", _hoisted_52, "TERBAYAR"))
                              : _createCommentVNode("", true),
                            (order.status == _ctx.constants.ORDER_SUCCESS_MANUAL)
                              ? (_openBlock(), _createBlock("div", _hoisted_53, "TERBAYAR"))
                              : _createCommentVNode("", true),
                            (order.status == _ctx.constants.ORDER_PENDING)
                              ? (_openBlock(), _createBlock("div", _hoisted_54, "BELUM BAYAR"))
                              : _createCommentVNode("", true),
                            (order.status == _ctx.constants.ORDER_BEGIN)
                              ? (_openBlock(), _createBlock("div", _hoisted_55, "AKTIF"))
                              : _createCommentVNode("", true),
                            (order.status == _ctx.constants.ORDER_REFUNDED)
                              ? (_openBlock(), _createBlock("div", _hoisted_56, "REFUNDED"))
                              : _createCommentVNode("", true),
                            (order.status == _ctx.constants.ORDER_PARTIAL_REFUND)
                              ? (_openBlock(), _createBlock("div", _hoisted_57, "REFUND SEBAGIAN"))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("td", null, _toDisplayString(_ctx.beautifyDatetime(order.expired_date)), 1),
                          _createVNode("td", null, [
                            (order.status == _ctx.constants.ORDER_SUCCESS || order.status == _ctx.constants.ORDER_SUCCESS_MANUAL)
                              ? (_openBlock(), _createBlock("span", _hoisted_58, _toDisplayString(_ctx.beautifyDatetime(order.payment_date)), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("td", null, [
                            _createVNode("span", _hoisted_59, _toDisplayString(order.description), 1)
                          ]),
                          _createVNode("td", null, [
                            _createVNode("a", {
                              class: "btn btn-light",
                              href: "#",
                              onClick: ($event: any) => (_ctx.orderDetail(order.id))
                            }, [
                              _hoisted_60,
                              _hoisted_61
                            ], 8, ["onClick"]),
                            (order.status == _ctx.constants.ORDER_REFUNDED || order.status == _ctx.constants.ORDER_PARTIAL_REFUND)
                              ? (_openBlock(), _createBlock("a", {
                                  key: 0,
                                  class: "btn btn-info",
                                  href: "#",
                                  onClick: ($event: any) => (_ctx.openRefundModal(order.id))
                                }, [
                                  _hoisted_62,
                                  _hoisted_63
                                ], 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ], 10, ["id", "aria-labelledby"]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_64, [
      _createVNode("div", _hoisted_65, [
        _createVNode("div", _hoisted_66, [
          _hoisted_67,
          _createVNode("div", _hoisted_68, [
            (_ctx.detailReady)
              ? (_openBlock(), _createBlock("div", _hoisted_69, [
                  _createVNode("table", _hoisted_70, [
                    _hoisted_71,
                    _createVNode("tbody", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.billUserInstallments, (detail) => {
                        return (_openBlock(), _createBlock("tr", {
                          key: detail.id
                        }, [
                          _createVNode("td", null, _toDisplayString(detail.bill_user.bill.name), 1),
                          _createVNode("td", null, [
                            _createVNode("span", _hoisted_72, _toDisplayString(_ctx.getMonth(detail.bill_user.id)), 1)
                          ]),
                          _createVNode("td", null, _toDisplayString(_ctx.beautifyDatetime(detail.deadline_date)), 1),
                          _createVNode("td", _hoisted_73, " Rp" + _toDisplayString(_ctx.toLocaleString(detail.amount)), 1)
                        ]))
                      }), 128)),
                      (_ctx.order.total_charge > 0)
                        ? (_openBlock(), _createBlock("tr", _hoisted_74, [
                            _hoisted_75,
                            _hoisted_76,
                            _hoisted_77,
                            _createVNode("td", _hoisted_78, " Rp" + _toDisplayString(_ctx.toLocaleString(_ctx.order.total_charge)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.order.convenience_fee > 0)
                        ? (_openBlock(), _createBlock("tr", _hoisted_79, [
                            _hoisted_80,
                            _hoisted_81,
                            _hoisted_82,
                            _createVNode("td", _hoisted_83, " Rp" + _toDisplayString(_ctx.toLocaleString(_ctx.order.convenience_fee)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.order.merchant_fee > 0)
                        ? (_openBlock(), _createBlock("tr", _hoisted_84, [
                            _hoisted_85,
                            _hoisted_86,
                            _hoisted_87,
                            _createVNode("td", _hoisted_88, " Rp" + _toDisplayString(_ctx.toLocaleString(_ctx.order.merchant_fee)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.order.ppn > 0)
                        ? (_openBlock(), _createBlock("tr", _hoisted_89, [
                            _hoisted_90,
                            _hoisted_91,
                            _hoisted_92,
                            _createVNode("td", _hoisted_93, " Rp" + _toDisplayString(_ctx.toLocaleString(_ctx.order.ppn)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("tr", null, [
                        _hoisted_94,
                        _createVNode("td", _hoisted_95, [
                          _createVNode("span", _hoisted_96, "Rp" + _toDisplayString(_ctx.toLocaleString(_ctx.order.total_payment)), 1)
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.order.us_order)
                    ? (_openBlock(), _createBlock("div", _hoisted_97, [
                        _hoisted_98,
                        _createVNode("p", null, _toDisplayString(_ctx.order.us_order.description), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.order.reference)
                    ? (_openBlock(), _createBlock("div", _hoisted_99, [
                        _hoisted_100,
                        (_ctx.order.reference.file_path)
                          ? (_openBlock(), _createBlock("p", _hoisted_101, [
                              _createVNode("a", {
                                href: _ctx.order.reference.file_path,
                                target: "_BLANK"
                              }, "Bukti Pembayaran", 8, ["href"])
                            ]))
                          : (_openBlock(), _createBlock("p", _hoisted_102, "Belum ada bukti pembayaran"))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_103
        ])
      ])
    ]),
    _createVNode("div", _hoisted_104, [
      _createVNode("div", _hoisted_105, [
        _createVNode("div", _hoisted_106, [
          _hoisted_107,
          _createVNode("div", _hoisted_108, [
            _createVNode("table", _hoisted_109, [
              _hoisted_110,
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.refundDetails, (detail, index) => {
                  return (_openBlock(), _createBlock("tr", { key: index }, [
                    _createVNode("td", null, _toDisplayString(detail.bill_name), 1),
                    _createVNode("td", null, [
                      _createVNode("span", _hoisted_111, _toDisplayString(detail.month), 1)
                    ]),
                    _createVNode("td", null, [
                      (detail.status == 'Refunded')
                        ? (_openBlock(), _createBlock("span", _hoisted_112, "Refunded"))
                        : (detail.status == 'Refund Sebagian')
                          ? (_openBlock(), _createBlock("span", _hoisted_113, "Refund Sebagian"))
                          : _createCommentVNode("", true)
                    ]),
                    _createVNode("td", _hoisted_114, "Rp" + _toDisplayString(_ctx.toLocaleString(detail.refund_amount)), 1)
                  ]))
                }), 128)),
                (_ctx.refundDetails.length === 0)
                  ? (_openBlock(), _createBlock("tr", _hoisted_115, [
                      _hoisted_116
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _hoisted_117,
            _createVNode("div", _hoisted_118, [
              _createVNode("div", _hoisted_119, [
                _createVNode("h5", _hoisted_120, [
                  _hoisted_121,
                  _createVNode("span", _hoisted_122, "Rp" + _toDisplayString(_ctx.toLocaleString(_ctx.totalRefund)), 1)
                ])
              ])
            ])
          ]),
          _hoisted_123
        ])
      ])
    ])
  ], 64))
}